<template>
  <div class="price">
    <div
      class="block price__block price__block--green"
      v-if="State.selection.incentive_type !== 'none'"
    >
      <div class="price__price-container">
        <p>Totaal eerste {{ State.selection.incentive_duration }} maanden:</p>
        <p class="price__price">{{ incentivePrice | toDisplayPrice }}</p>
      </div>
      <div class="price__price-container">
        <p>Daarna per maand:</p>
        <p class="price__price">{{ price | toDisplayPrice }}</p>
      </div>
    </div>
    <div class="block price__block price__block--green" v-else>
      <div class="price__price-container">
        <p v-if="State.Zoekgegevens.cust_type==='thuis'">Per maand:</p>
        <p v-else>Per maand (excl. btw):</p>
        <p class="price__price">{{ price | toDisplayPrice }}</p>
      </div>
    </div>
    <div class="price__price-container">
      <p>Eenmalige kosten</p>
      <p class="price__price">{{ OneTimePrice | toDisplayPrice }}</p>
    </div>
  </div>
</template>

<script>
import priceFilters from '../filters/priceFilters'
import State from '../state.js'

export default {
  props: {
    price: Number,
    incentivePrice: Number,
    OneTimePrice: Number
  },
  data () {
    return { State: State }
  },
  filters: {
    toDisplayPrice: priceFilters.toDisplayPrice
  }
}
</script>

<style lang="scss" scoped>
.price {
  display: flex;
  flex-direction: column;

  font-weight: 700;
  font-size: 1em;
  margin-top: 20px;
}

.price__price-container {
  display: flex;
  justify-content: space-between;

  p {
    margin: 5px 0;
    display: inline-block;
    width: max-content;
  }
}

.price__price {
  display: inline-block;
  text-align: right;

  width: max-content;
}
.price__block {
  width: calc(100% + 20px);
  align-self: center;

  & > :last-child {
    font-size: 0.9em;
  }

  .price__price-container {
    margin: 0 4%;
  }
}

div.price__block--green {
  background-color: color('popout');
  color: color(6);
}
</style>
